import { render, staticRenderFns } from "./PersonProfileHistoryRow.vue?vue&type=template&id=1e16a1e2&scoped=true&"
import script from "./PersonProfileHistoryRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e16a1e2",
  null
  
)

export default component.exports